import {Injectable} from '@angular/core';
import {EmployeeEventResponseSummary} from "../../company/_models/employee/employee-event-response-summary";
import {AlertLevel} from "../../../enums/alert-level";
import {GlobalAlertService} from "../../../_services/global-alert.service";

import {createEvents, EventAttributes} from 'ics';

@Injectable({
  providedIn: 'root'
})
export class IcsService {
  constructor(private gas: GlobalAlertService) {
  }

  download(responses: EmployeeEventResponseSummary[]) {
    const events = responses.map(response => {
      const start = response.start ?? response.eventStart;
      const end = response.end ?? response.eventEnd;

      let description: string = `Einteilung: ${response.locationName}\n\n`;
      if (!response.eventPublicDescription.isNullOrWhitespace()) {
        description += `Anmerkungen:\n${response.eventPublicDescription}\n\n`;
      }
      description += `Powered by CheqMe.`;

      const ea: EventAttributes = {
        uid: response.id,
        sequence: parseInt(((new Date().getTime() - response.created.getTime()) / 1000).toFixed(0)),
        start: [start.getFullYear(), start.getMonth() + 1, start.getDate(), start.getHours(), start.getMinutes()],
        end: [end.getFullYear(), end.getMonth() + 1, end.getDate(), end.getHours(), end.getMinutes()],
        title: response.eventName,
        description: description,
        location: response.shardName,
        busyStatus: 'BUSY',
        alarms: [
          {action: 'audio', trigger: '-PT60M'},
          {action: 'display', trigger: '-PT60M'},
        ]
      };
      return ea;
    })
    createEvents(events, (error: any, value: any) => {
      if (error) {
        console.log(error)
        this.gas.createAndShow("Fehler", 'Fehler beim Erstellen der ICS-Datei.', AlertLevel.error);
        return
      }
      const blob = new Blob([value], {type: 'text/calendar;charset=utf-8'})
      const url = window.URL.createObjectURL(blob)
      window.open(url, '_blank')
    });
  }
}
